module.exports = __webpack_public_path__ + "img/power-level-2.90bbe6a8.png";